import { Box, Icon, InlineStack } from '@customerio/pluma-components/react';
import { PhonePreview, PUSH_TEST_BODY, PUSH_TEST_TITLE, type PushPlatform } from '@/features/push-credentials';
import * as styles from './styles.css';

export type AppPushPreviewProps = {
  appName: string;
  platform: PushPlatform | null;
};

export function AppPushPreview({ appName, platform }: AppPushPreviewProps) {
  return (
    <PhonePreview
      title={PUSH_TEST_TITLE}
      body={PUSH_TEST_BODY}
      notificationClassName={styles.previewNotification}
      header={
        <InlineStack alignBlock="center" alignInline="space-between" mb="100">
          <InlineStack alignBlock="center" gap="075">
            {platform == null ? null : <Icon name={platform === 'ios' ? 'apple' : 'android'} aria-hidden={true} />}
            <Box as="span" className={styles.previewAppName}>
              {appName.toUpperCase()}
            </Box>
          </InlineStack>
          <Box as="span" className={styles.previewTime}>
            now
          </Box>
        </InlineStack>
      }
    />
  );
}
